import React from 'react';

/**
 * E3 Summit brand mark — 22×22 rounded square in --accent with three
 * white horizontal bars. Used in the sidebar brand block. When the real
 * logo SVG is available, replace the path data inside; the outer wrapper
 * already matches the design's spec (rx=7, accent fill).
 */
export default function Logo({ mono = false, size = 22 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-label="E3 Summit"
    >
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="7"
        fill={mono ? 'transparent' : 'var(--accent)'}
        stroke={mono ? 'var(--text-1)' : 'transparent'}
        strokeWidth="1.5"
      />
      <path
        d="M10 9h12M10 16h9M10 23h12"
        stroke={mono ? 'var(--text-1)' : 'white'}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
